import http from "@/services/http";
import {useAuth} from "@/services/auth.js";

export const produtos = () => {
  const auth = useAuth();

  async function list(page = 1, storeId = null) {
    let retorno;
    try {
        let url = '/products?page=' + page;
        if (storeId) url += '&store_id=' + storeId;
        const {data} = await http.get(url, auth.getBearer( ));
        retorno = data;
    } catch (error) {
        console.log(error?.response?.data);
    }
    return retorno;
  }

  // Catálogo completo pra busca client-side (ex.: montar um orçamento) —
  // diferente de list(), que é paginado pra tela de produtos.
  async function listAll() {
    try {
      const { data } = await http.get('/products?per_page=1000', auth.getBearer());
      return data?.data ?? [];
    } catch (error) {
      console.log(error?.response?.data);
      return [];
    }
  }

  async function createItem(produto) {
    try {
      const {data} = await http.post('/products', produto, auth.getBearer());
      return true;
    } catch (error) {
      console.log(error?.response?.data);
      // Ex.: bloqueio por limite do plano (ver EnforcesPlanLimits no
      // backend) — a tela precisa da mensagem real, não só saber que falhou.
      return error?.response?.data?.message ?? 'Não foi possível cadastrar o produto.';
    }
  }

  async function deleteItem(id) {
    try {
      const {data} = await http.delete('/products/'+id, auth.getBearer());
      return true;
    } catch (error) {
      console.log(error?.response?.data);
      return false;
    }
  }

  async function updateItem(produto) {
    try {
      const {data} = await http.put('/products/'+produto.id, produto, auth.getBearer());
      return true;
    } catch (error) {
      console.log(error?.response?.data);
      return false;
    }
  }

  async function descart(id, form) {
    try {
      const {data} = await http.post('/products/'+id+'/discard', form, auth.getBearer());
      return true;
    } catch (error) {
      console.log(error?.response?.data);
      return false;
    }
  }

  async function replace(id, form) {
    try {
      const {data} = await http.post('/products/'+id+'/restock', form, auth.getBearer());
      return true;
    } catch (error) {
      console.log(error?.response?.data);
      return false;
    }
  }

  return {list, listAll, createItem, deleteItem, updateItem, descart, replace}

}
